import { UploadFile } from "../../generated/graphql-types";
import { LocalMediaRef, MediaRef } from "@/app/__to_be_integrated/_____components/image/enhanced-image/types/types";

export function isLocalMediaRef(image: MediaRef | null): image is LocalMediaRef {
    if (typeof image === 'string') return false;
    return image !== null && image !== undefined && 'file' in image;
}

export function isUploadFile(image: MediaRef | null): image is UploadFile {
    if (typeof image === 'string') return false;
    return image !== null && image !== undefined && 'url' in image;
}